module.exports = __webpack_public_path__ + "static/media/indent.5f88dbc9.svg";